import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HasSubscriptionGuard } from '@spaq/core/guards/has-subscription.guard';
import { IsAdminGuard } from '@spaq/core/guards/is-admin.guard';
import { IsLoggedInGuard } from '@spaq/core/guards/is-logged-in.guard';
import { IsVerifiedGuard } from '@spaq/core/guards/is-verified.guard';
import { LayoutAccountComponent } from '@spaq/core/layout/account/layout-account.component';

const routes: Routes = [
	{ path: '', redirectTo: 'auth', pathMatch: 'full' },
	{ path: 'auth', loadChildren: () => import('./public/public.module').then(m => m.PublicModule) },
	{ path: '__', loadChildren: () => import('./public/public.module').then(m => m.PublicModule) },
	{
		path: 'account',
		component: LayoutAccountComponent,
		canActivate: [IsLoggedInGuard, IsVerifiedGuard, HasSubscriptionGuard],
		loadChildren: () => import('./private/private.module').then(m => m.PrivateModule)
	},
	{
		path: 'admin',
		canActivate: [IsLoggedInGuard, IsVerifiedGuard, HasSubscriptionGuard, IsAdminGuard],
		loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
	},
	{ path: '**', redirectTo: 'auth', pathMatch: 'full' } // Pour gérer les routes inconnues
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { enableTracing: false })],
	exports: [RouterModule],
	declarations: []
})
export class WebRoutingModule {}
